import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.ScreeningSuccessModal .BaseModal-Body {
    padding: ${spacing(10)};
    max-width: 480px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: ${spacing(5)};

    > .screening-success-content {
      display: contents;
    }
  }

  .success-image {
    width: 120px;
    height: 120px;
  }

  .success-title {
    font-family: ${font_family_weight_medium};
    ${font_lg}
    color: ${text_colorTextPrimary};
  }

  .success-message {
    font-family: ${font_family_weight_regular};
    ${font_md}
    color: ${text_colorTextSecondary};
  }
`
